import(/* webpackMode: "eager" */ "/app/main/app/[locale]/dtb/list/[yearKey]/page.tsx");
